/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type VehicleForUnarchiveQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type VehicleForUnarchiveQuery = {
  __typename?: 'Query'
  vehicle: { __typename?: 'Vehicle'; id: string; tenant: string }
}

export const VehicleForUnarchiveDocument = gql`
    query VehicleForUnarchive($vehicleId: ID!) {
  vehicle: vehicleByID(id: $vehicleId) {
    id
    tenant
  }
}
    `

/**
 * __useVehicleForUnarchiveQuery__
 *
 * To run a query within a React component, call `useVehicleForUnarchiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleForUnarchiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleForUnarchiveQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useVehicleForUnarchiveQuery(
  baseOptions: Apollo.QueryHookOptions<
    VehicleForUnarchiveQuery,
    VehicleForUnarchiveQueryVariables
  > &
    (
      | { variables: VehicleForUnarchiveQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VehicleForUnarchiveQuery,
    VehicleForUnarchiveQueryVariables
  >(VehicleForUnarchiveDocument, options)
}
export function useVehicleForUnarchiveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VehicleForUnarchiveQuery,
    VehicleForUnarchiveQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VehicleForUnarchiveQuery,
    VehicleForUnarchiveQueryVariables
  >(VehicleForUnarchiveDocument, options)
}
// @ts-ignore
export function useVehicleForUnarchiveSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VehicleForUnarchiveQuery,
    VehicleForUnarchiveQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VehicleForUnarchiveQuery,
  VehicleForUnarchiveQueryVariables
>
export function useVehicleForUnarchiveSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehicleForUnarchiveQuery,
        VehicleForUnarchiveQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VehicleForUnarchiveQuery | undefined,
  VehicleForUnarchiveQueryVariables
>
export function useVehicleForUnarchiveSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehicleForUnarchiveQuery,
        VehicleForUnarchiveQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    VehicleForUnarchiveQuery,
    VehicleForUnarchiveQueryVariables
  >(VehicleForUnarchiveDocument, options)
}
export type VehicleForUnarchiveQueryHookResult = ReturnType<
  typeof useVehicleForUnarchiveQuery
>
export type VehicleForUnarchiveLazyQueryHookResult = ReturnType<
  typeof useVehicleForUnarchiveLazyQuery
>
export type VehicleForUnarchiveSuspenseQueryHookResult = ReturnType<
  typeof useVehicleForUnarchiveSuspenseQuery
>
export type VehicleForUnarchiveQueryResult = Apollo.QueryResult<
  VehicleForUnarchiveQuery,
  VehicleForUnarchiveQueryVariables
>
